module.exports = __webpack_public_path__ + "img/sb02.aee1f5fd.png";